import { Link, SectionHeader, Typography } from 'web-library';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTOCStyles } from '../../../pages/helpdesk/TermsOfUse';

const LinkTermsOfUse = () => {
  const { classes } = useTOCStyles();
  const { t } = useTranslation();

  return (
    <>
      <SectionHeader title="Hyperlinks and Links to this Web Site from other web sites" />
      <ol start={14}>
        <li className={classes.paragraph}>
          <Typography variant="body1">
            {`This Web Site contains hyperlinks to web sites which are not maintained by SEAB. ` +
              `SEAB is not responsible for the contents of those web sites and shall not be liable for any damages or ` +
              `loss arising from access to those web sites. Use of the hyperlinks and access to such web sites ` +
              `are entirely at your own risk.`}
          </Typography>
        </li>
        <li className={classes.paragraph}>
          <Typography variant="body1">
            {`Hyperlinks to other web sites are provided as a convenience. In no circumstances shall ` +
              `SEAB be considered to be associated or affiliated with any trade or service marks, logos, ` +
              `insignia or other devices used or appearing on web sites to which this Web Site is linked.`}
          </Typography>
        </li>
        <li className={classes.paragraph}>
          <Typography variant="body1">
            {`Except as set forth below, caching and links to, and the framing of this Web Site or any ` +
              `of the Contents are prohibited.`}
          </Typography>
        </li>

        <li className={classes.paragraph}>
          <Typography variant="body1">
            {`You must secure permission from SEAB prior to hyperlinking to, or framing, this Web ` +
              `Site or any of the Contents, or engaging in similar activities. SEAB reserves the right to impose ` +
              `conditions when permitting any hyperlinking to, or framing of this Web Site or any of the ` +
              `Contents.`}
          </Typography>
        </li>

        <li className={classes.paragraph}>
          <Typography variant="body1">
            {`Your linking to, or framing any part of this Web Site or its Contents constitute ` +
              `acceptance of these Terms of Use. This is deemed to be the case even after the posting of any ` +
              `changes or modifications to these Terms of Use. If you do not accept these Terms of Use, you ` +
              `must discontinue linking to, or framing of this Web Site or any of the Contents.`}
          </Typography>
        </li>

        <li className={classes.paragraph}>
          <Typography variant="body1">
            {`In no circumstances shall SEAB be considered to be associated or affiliated in whatever ` +
              `manner with any trade or service marks, logos, insignia or other devices used or appearing on ` +
              `web sites that link to this Web Site or any of the Contents.`}
          </Typography>
        </li>

        <li className={classes.paragraph}>
          <Typography variant="body1">
            {`SEAB reserves all rights to disable any links to, or frames of any site containing ` +
              `inappropriate, profane, defamatory, infringing, obscene, indecent or unlawful topics, names, ` +
              `material or information, or material or information that violates any written law, any applicable ` +
              `intellectual property, proprietary, privacy or publicity rights.`}
          </Typography>
        </li>

        <li className={classes.paragraph}>
          <Typography variant="body1">
            {`SEAB reserves the right to disable any unauthorized links or frames and disclaims any ` +
              `responsibility for the content available on any other site reached by links to or from this Web ` +
              `Site or any of the Contents.`}
          </Typography>
        </li>

        <li className={classes.paragraph}>
          <Typography variant="body1">
            {`If you choose to make an application or send SEAB an email providing SEAB with your ` +
              `personal data, SEAB may, if necessary, share your personal data with other Government ` +
              `agencies, or with non-Government entities which have been authorised by SEAB for the ` +
              `purpose of carrying out e-services in the Candidates Portal (the "`}
            <b>e-Service</b>
            {`"), so as to provide ` +
              `exam services to you in the most efficient and effective way, unless such data sharing is ` +
              `prohibited by law.`}
          </Typography>
        </li>

        <li className={classes.paragraph}>
          <Typography variant="body1">
            {`You may inform us in writing that you do not consent to such sharing of your personal ` +
              `data. Please note that your withdrawal of consent could affect the service level of the delivery ` +
              `of exam services to you. For queries about SEAB personal data sharing policy or to inform us that ` +
              `you do not consent to share your personal data, please contact QSM at Tel: 6970 6255 or `}
            <Link href={t('helpdesk->>Links.SEAB QSM Email')} withUnderline>
              seab_qsm@seab.gov.sg
            </Link>
          </Typography>
        </li>

        <li className={classes.paragraph}>
          <Typography variant="body1">
            {`For your convenience, SEAB may display to you data you had previously supplied to ` +
              `SEAB or other Government agencies. This will speed up the transaction and save you the ` +
              `trouble of repeating previous submissions. Should the data be inaccurate or out-of-date, please ` +
              `supply SEAB with the latest data. SEAB will retain the data only as necessary for the effective ` +
              `delivery of public services to you.`}
          </Typography>
        </li>

        <li className={classes.paragraph}>
          <Typography variant="body1">
            {`You shall ensure that all information submitted through the e-Service is complete, ` +
              `accurate, true and correct. Where supporting documents are requested / needed, you should ` +
              `ensure all information submitted through the e-Service is consistent with the supporting ` +
              `documents. Failure to do so may result in delays in processing or rejection of the application. ` +
              `You may be liable for costs incurred due to false or incorrect information submitted.`}
          </Typography>
        </li>

        <li className={classes.paragraph}>
          <Typography variant="body1">
            {`While every care is taken by SEAB in providing the e-Service, the Government disclaims ` +
              `all liability whatsoever, provides no warranty that access to the e-Service will be provided ` +
              `uninterrupted or free from error or that any identified defect will be corrected, and disclaims ` +
              `all liability for any direct, incidental or consequential damage or loss, that may result from such ` +
              `interruptions or errors or defects, including but not limited to:`}
          </Typography>

          <ol type="a">
            <li className={classes.paragraph}>
              <Typography variant="body1">
                {`any loss of, or any inability to retrieve, any data or information however caused as a result ` +
                  `of any interruption, suspension or termination of service; and`}
              </Typography>
            </li>

            <li className={classes.paragraph}>
              <Typography variant="body1">
                any inaccuracy in the information presented, used or transmitted through the
                e-Service.
              </Typography>
            </li>
          </ol>
        </li>
      </ol>
    </>
  );
};

export default LinkTermsOfUse;
